import { LoginService } from "@services/login.service.ajs";
import { SessionService } from "@services/session.service";
import * as angular from "angular";
import * as levenshtein from "js-levenshtein";
import "./home.component.scss";

class HomeComponentController implements angular.IComponentController {

    static $inject = ["$window", "$location", "$timeout", "loginService", "sessionService"];

    constructor(
        private readonly $window: angular.IWindowService,
        private readonly $location: angular.ILocationService,
        private readonly $timeout: angular.ITimeoutService,
        private readonly loginService: LoginService,
        private readonly sessionService: SessionService) {}

    // ---

    levenshtein(input1: string, input2: string) {
        var distance = levenshtein(input1, input2);
    }
}

export class HomeComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: string;

    constructor() {
        this.bindings = {};

        this.controller = HomeComponentController;
        this.template = require("./home.component.html");
    }
}
